const tutorialPopUpTranslations = {
  title: "شرح استخدام المنصة",
};

export default tutorialPopUpTranslations;
